import { render } from "./Vita.vue?vue&type=template&id=5e5210fb&scoped=true"
import script from "./Vita.vue?vue&type=script&lang=js"
export * from "./Vita.vue?vue&type=script&lang=js"

import "./Vita.vue?vue&type=style&index=0&id=5e5210fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5210fb"]])

export default __exports__